<template>
  <CommonModal>
    <SpinningLoader :pending="pending">
      <div
        :class="{ 'invisible' : lot.lastBidUuid }"
        class="font-bold text-center mb-4"
      >
        {{ $t("lot.you_are_preempting") }} {{ lot.code }}
      </div>

      <LotRecapRedistribute
        :lot="lot"
        :product-map="productMap"  
        :in-modal="true"
      />

      <div class="absolute bottom-0 mb-5 w-full">
        <div class="flex justify-around">
          <div>
            <a
              href="#"
              class="btn btn-cancel"
              @click.prevent="$emit('close')"
            >{{ $t("common.close") }}</a>
          </div>
          <div>
            <a
              href="#"
              class="btn btn-cta"
              @click.prevent="preemptSync"
            >{{ $t("lot.preempt") }}</a>
          </div>
        </div>
      </div>
    </SpinningLoader>
  </CommonModal>
</template>
  
<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n'

import CommonModal from '@/components/CommonModal.vue';
import SpinningLoader from '@/components/SpinningLoader.vue';
import useAxios from '@/composables/axios';
import { useNotificationsStore } from '@/stores/notifications';

import LotRecapRedistribute from './LotRecapRedistribute.vue';
  
const { pushSuccess, pushError } = useNotificationsStore();
const axios = useAxios()
const { t } = useI18n()

const pending = ref(false);

const emit = defineEmits(['close', 'update-auction'])
const props = defineProps({
  auction: {
    type: Object,
    required: true
  },
  lot: {
      type: Object,
      required: true
  },
  productMap: {
      type: Object,
      required: true
  },
})

const preemptSync = async function() {
  pending.value = true;

  await axios.post('/auction/bidRedistribute-sync/' + props.auction.uuid + '/' + props.lot.uuid).then(bidResponse => {
    pushSuccess(t('lot.redistributed_with_success'));
    emit('close');
    emit('update-auction', bidResponse.data);
  }).catch(error => {
    pushError(t('lot.relaunch_error'));
    pending.value = false;
    emit('close');
  });

}
</script>
  